import React, { useEffect, useState } from "react";
import { Text, TouchableOpacity, View, StyleSheet, Platform } from "react-native";

import AppTheme from "../../AppTheme";
import ImageComponent from "../../common/ImageComponent";
import RoundCheckbox from "../../common/RoundCheckbox";

const ReportUser = ({ user, toggleSelection }) => {
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(user.isSelected);
  }, [user.isSelected]);

  return (
    <TouchableOpacity
      onPress={toggleSelection ? () => toggleSelection(user) : null}
      style={[styles.user]}
    >
      {user.avatar ? (
        <ImageComponent image={user.avatar} style={styles.avatar} />
      ) : (
        <View style={{ width: 26, marginLeft: 16 }} />
      )}
      <View style={[{ flex: 1, flexDirection: "column", flex: 1 }]}>
        <Text style={styles.userName}>{user.name}</Text>
        <Text style={styles.info}>{user.companyInfo}</Text>
      </View>

      {toggleSelection ? (
        <RoundCheckbox
          size={16}
          checked={isSelected}
          onValueChange={() => toggleSelection(user)}
        />
      ) : null}
    </TouchableOpacity>
  );
};

export default ReportUser;

const styles = StyleSheet.create({
  user: {
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: AppTheme.borderColor,
  },
  userName: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  info: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  avatar: {
    width: 20,
    height: 20,
    borderRadius: 100,
    //marginLeft: 16,
    marginRight: 6,
  },
});
